import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import VelocityTransitionGroup from 'velocity-react/velocity-transition-group';
import _ from 'lodash';
import moment from 'moment';

import { RoundLoader } from 'components/widgets/state-indicators/loader';
import { getFileOpenUrl } from 'utils/google-drive-utils';
import { slideClosed, slideOpen } from 'utils/transition-groups';
import { stopPropagation } from 'utils/event-handlers';
import File from 'services/data/file';
import Overlay from 'praece-react-bootstrap/lib/Overlay';
import Popover from 'praece-react-bootstrap/lib/Popover';
import SVG from 'components/widgets/icons/svg';
import docIcon from 'assets/file-icons/doc.png';
import sheetIcon from 'assets/file-icons/sheet.png';
import slideIcon from 'assets/file-icons/slide.png';

import DriveFile from './drive-file';
import DriveFolderLink from './drive-folder-link';


class DriveFilesList extends React.Component {
  constructor() {
    super();

    this.state = { showPopover: false };
    this.addFile = this.addFile.bind(this);
    this.show = () => this.setState({ showPopover: true });
    this.hide = () => this.setState({ showPopover: false });
  }

  componentDidMount() {
    if (this.props.files) return;

    return File.list(this.props.folder.id)
      .then(items => {
        this.setState({ items });
      });
  }

  addTemplate(template) {
    this.setState({ adding: 'template' });
    this.hide();

    this.saveFile(template.id, template.fullName);
  }

  addFile(type) {
    if (this.state.adding) return;

    this.setState({ adding: type });
    const { settings } = this.props;
    const now = moment().format('YYYYMMDD');
    const template = {
      document: settings.documentBaseTemplate,
      spreadsheet: settings.sheetBaseTemplate,
      presentation: settings.slideBaseTemplate,
      form: settings.formBaseTemplate
    }[type];

    this.saveFile(template, `${now} - [${type} title]`);
  }

  saveFile(template, fileName) {
    const { folder, onFileAdd } = this.props;

    File.addToFolder(folder.id, { template, fileName })
      .tap(file => {
        this.setState({ adding: false });
        window.open(getFileOpenUrl(file.id), '_blank');
      })
      .tap(file => {
        if (onFileAdd) onFileAdd(file);
      });
  }

  render() {
    const { folder, templates } = this.props;
    const { adding, showPopover } = this.state;
    const items = this.props.files || this.state.items;
    const bases = _(this.props.settings).pickBy((value, key) => _.includes(key, 'Template')).values().value();

    const filteredTemplates = _.filter(templates, template => {
      const isBase = _.includes(bases, template.id);

      return !isBase;
    });

    const formattedTemplates = _.map(filteredTemplates, template => {
      const name = _.split(template.name, ' YYYYMMDD')[0];

      return _.defaults({ name, fullName: template.name }, template);
    });

    return (
      <div>
        <div className="drive-list-add-files-header">
          <h3 className="drive-add-file-link" onClick={() => this.addFile('document')}>
            { adding === 'document' ? <RoundLoader color="#34495e" /> : <img src={docIcon} alt="Add Doc" />}
            <span>Add Doc</span>
          </h3>
          <h3 className="drive-add-file-link" onClick={() => this.addFile('spreadsheet')}>
            { adding === 'spreadsheet' ? <RoundLoader color="#34495e" /> : <img src={sheetIcon} alt="Add Sheet" />}
            <span>Add Sheet</span>
          </h3>
          <h3 className="drive-add-file-link" onClick={() => this.addFile('presentation')}>
            { adding === 'presentation' ? <RoundLoader color="#34495e" /> : <img src={slideIcon} alt="Add Slide" />}
            <span>Add Slides</span>
          </h3>
          <h3 className="drive-add-file-link" onClick={this.show} ref={el => { this.templateOption = el; }}>
            { adding === 'template' ? <RoundLoader color="#34495e" /> : <SVG src="svg/clipboard.svg" />}
            <span>Template</span>
            <Overlay
              shouldUpdatePosition
              rootClose
              placement="bottom"
              target={this.templateOption}
              onHide={this.hide}
              show={showPopover}
            >
              <Popover
                id="drive-files-window"
                className="clickable-options-list p-0"
                onClick={stopPropagation()}
                onMouseOver={stopPropagation()}
              >
                <ul className="unstyled-list drive-files-list">
                  {_.map(formattedTemplates, item =>
                    <DriveFile item={item} key={item.id} onClick={() => this.addTemplate(item)} />
                  )}
                </ul>
              </Popover>
            </Overlay>
          </h3>
        </div>
        <ul className="unstyled-list">
          <li className="drive-folder-external-link">
            <DriveFolderLink folder={folder} />
          </li>
          
        </ul>
        <VelocityTransitionGroup className="unstyled-list drive-files-list" component="ul" leave={slideClosed} enter={slideOpen}>
          {_.map(items, item =>
            <DriveFile item={item} key={item.id} />
          )}
        </VelocityTransitionGroup>
        
      </div>
    );
  }
}

DriveFilesList.propTypes = {
  folder: PropTypes.object.isRequired,
  files: PropTypes.array,
  onFileAdd: PropTypes.func,
  settings: PropTypes.object,
  templates: PropTypes.array
};

// Exports
export default connect((state) => ({
  settings: state.pageData.settings,
  templates: state.pageData.templateFiles
}))(DriveFilesList);
